<template>
  <section class="all_plan_2">
    <div class="font_box_2">
      <h3>方案总览</h3>
      <p>Flyme Auto Core 源自 Flyme OS，延续 Flyme 在手机领域优秀的设计理念并把它带到了汽车座舱，整合了丰富的生态内容，为用户提供无缝的跨端互联能力及一站式的娱乐体验，致力于打造次世代的智能座舱</p>
    </div>

    <ul class="plan_box_2">
      <li class="plan_item_2" v-for="(item, key) in planList" :key="key">
        <div class="plan_logo_2" :style="`background-image: url(${item.logo})`"></div>
        <h5 class="title_2">{{ item.title }}</h5>
        <ul class="plan_list_box_2">
          <li class="plan_2" v-for="it in item.funcs" :key="it">{{ it }}</li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
import img1 from '@/plan/assets/image/2/1.png'
import img2 from '@/plan/assets/image/2/2.png'
import img3 from '@/plan/assets/image/2/3.png'
import img4 from '@/plan/assets/image/2/4.png'
import img5 from '@/plan/assets/image/2/5.png'
import img6 from '@/plan/assets/image/2/6.png'
export default {
  name: 'AllPlan',

  data() {
    return {
      planList: Object.freeze(
        [
          {
            logo: img1,
            title: '互联融合',
            funcs: ['Flyme Link', '妙连 SDK', 'Fast OTA']
          },
          {
            logo: img2,
            title: '生态融合',
            funcs: ['应用生态', '游戏生态', '主题生态', '生态商业化']
          },
          {
            logo: img3,
            title: '端云一体能力',
            funcs: ['Flyme ID', 'Flyme 支付', 'Push 推送', '大数据', '统一运营门户']
          },
          {
            logo: img4,
            title: '软硬协同能力',
            funcs: ['硬件协同 SDK']
          },
          {
            logo: img5,
            title: '性能体验',
            funcs: ['知意动效', '性能优化']
          },
          {
            logo: img6,
            title: '智能服务',
            funcs: ['语音助手', '智能地图']
          }
        ]
      )
    }
  }
}
</script>


<style lang="less" scoped>
.all_plan_2 {
  height: 1249px;
  background-color: #F7F8FA;
}

.font_box_2 {
  width: 920px;
  margin: auto;
  padding: 115px 0 60px 0;

  h3 {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;
    text-align: center;
    margin: 0;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
    margin: 10px 0 0 0;
    color: rgba(0, 0, 0, 0.5);
  }
}

.plan_box_2 {
  margin: auto;
  width: 1193px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .plan_item_2 {
    background-color: #fff;
    width: 384px;
    height: 420px;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 20px 0 0;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.plan_logo_2 {
  width: 90px;
  height: 90px;
  margin: 70px 0 30px 0;
  background-size: 100% 100%;
}
.title_2 {
  width: 282px;
  font-weight: 700;
  font-size: 26px;
  line-height: 37px;
  text-align: center;
  color: #000000;
}
.plan_list_box_2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 282px;
  margin-top: 12px;
  
  .plan_2 {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
